import { useState } from "react";
import { H5, Image, LI, P , Btn} from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service";
import UserProfileIcons from "./UserProfileIcons";
import { FaSortDown } from "react-icons/fa";
const UserProfile = () => {
  const [show,setShow] =  useState(false)
  const [userName, setUserName] = useState(localStorage.getItem('UserName'));
  const [MemberName, setMemberName] = useState (localStorage.getItem('MemberName'))
  return (
    <LI className="profile-dropdown custom-dropdown">
      <div className="d-flex align-items-center" onClick={()=>setShow(!show)}>
        <Image src={dynamicImage("default_user.png")} alt="avatar" />
        <div className="flex-grow-1 d-none d-md-block">
         <div>
         <span> {MemberName} <span></span></span>
          {/* <div className="d-flex justify-content-between align-items-center rounded pe-2" style={{border:'2px solid #3bf7ee'}}>
          <div ><Btn className="btn btn-primary py-0 rounded-1">Rank</Btn></div>
          <P className="flex-grow-1" style={{fontSize:12}}>Manager</P>
          </div> */}
          </div>
          {/* <div>
            <P style={{fontSize:10, fontWeight:900}}></P>
          </div> */}
        </div>
        <span className="text-white"><FaSortDown /></span>
      </div>
      <div className={`custom-menu overflow-hidden ${show? "show" : ""}`}>
        <UserProfileIcons />
      </div>
    </LI>
  );
};

export default UserProfile;
